/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './scheme-community.reducer';

export const SchemeCommunityDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const schemeCommunityEntity = useAppSelector(state => state.schemeCommunity.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="schemeCommunityDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.schemeCommunity.detail.title">SchemeCommunity</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.schemeCommunity.id">Id</Translate>
            </span>
          </dt>
          <dd>{schemeCommunityEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.schemeCommunity.active">Active</Translate>
            </span>
          </dt>
          <dd>{schemeCommunityEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.schemeCommunity.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{schemeCommunityEntity.cursor}</dd>
          <dt>
            <span id="lastUpdate">
              <Translate contentKey="tinyMedicRestApp.schemeCommunity.lastUpdate">Last Update</Translate>
            </span>
          </dt>
          <dd>{schemeCommunityEntity.lastUpdate}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.schemeCommunity.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{schemeCommunityEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.schemeCommunity.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{schemeCommunityEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.schemeCommunity.scheme">Scheme</Translate>
          </dt>
          <dd>{schemeCommunityEntity.scheme ? schemeCommunityEntity.scheme.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.schemeCommunity.community">Community</Translate>
          </dt>
          <dd>{schemeCommunityEntity.community ? schemeCommunityEntity.community.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/scheme-community" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/scheme-community/${schemeCommunityEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SchemeCommunityDetail;
